export const allReceptionPlacesColumns = (t: any) => [
  {
    key: "receptionPlaceAddress",
    name: t('receptionPlaces.columns.receptionPlaceAddress'),
    fieldName: 'receptionPlaceAddress',
    minWidth: 200,
    maxWidth: 250,
    isResizable: true,
  },
  {
    key: "bdoNumber",
    name: t('receptionPlaces.columns.bdoNumber'),
    fieldName: 'bdoNumber',
    minWidth: 100,
    maxWidth: 250,
    isResizable: true,
  },
  {
    key: "phone",
    name: t('receptionPlaces.columns.phone'),
    fieldName: 'phone',
    minWidth: 100,
    maxWidth: 250,
    isResizable: true,
  },
  {
    key: "companyName",
    name: t('receptionPlaces.columns.companyName'),
    fieldName: 'companyName',
    minWidth: 150,
    maxWidth: 250,
    isResizable: true,
  },
  {
    key: "orderType",
    name: t('receptionPlaces.columns.orderType'),
    fieldName: 'orderType',
    minWidth: 150,
    maxWidth: 250,
    isResizable: true,
    onRender: (item: any) => {
      const map: any = {
        "Kontener": t('orders.typeValues.container'),
        "Tonaż":    t('orders.typeValues.tonnage'),
        "Pojazd":   t('orders.typeValues.vehicle'),
      };
      return map[item.orderType] !== undefined ? map[item.orderType] : item.orderType;
    },
  },
  {
    key: "containersAmount",
    name: t('receptionPlaces.columns.containersAmount'),
    fieldName: 'containersAmount',
    minWidth: 100,
    maxWidth: 250,
    isResizable: true,
  },
  {
    key: "importedFromCuo",
    name: t('receptionPlaces.columns.importedFromCuo'),
    fieldName: 'importedFromCuo',
    minWidth: 100,
    maxWidth: 150,
    isResizable: true,
  },
];